import { render } from "./AccountDetails.vue?vue&type=template&id=17b2b2a1&scoped=true"
import script from "./AccountDetails.vue?vue&type=script&lang=js"
export * from "./AccountDetails.vue?vue&type=script&lang=js"

import "./AccountDetails.vue?vue&type=style&index=0&id=17b2b2a1&scoped=true&lang=css"

import exportComponent from "D:\\Partheas\\Projects\\VDAB\\Code\\qpp-view\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17b2b2a1"]])

export default __exports__